export default "/_next/static/images/16c557ecad9855fdaf9367b98ce8be75.svg";